import { useEffect } from "react";

export const useGlobalPaste = (onFilesPaste) => {
  useEffect(() => {
    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      const files = [];

      for (let item of items) {
        if (item?.kind === "file") {
          const file = item.getAsFile();
          if (file) files.push(file);
        }
      }

      if (files.length) {
        onFilesPaste(files, e);
      }
    };

    window.addEventListener("paste", handlePaste);

    return () => {
      window.removeEventListener("paste", handlePaste);
    };
  }, [onFilesPaste]);
};
